import { render, staticRenderFns } from "./GoodsMultiplePickerWithCategory.vue?vue&type=template&id=31f0cfbe&scoped=true"
import script from "./GoodsMultiplePickerWithCategory.vue?vue&type=script&lang=js"
export * from "./GoodsMultiplePickerWithCategory.vue?vue&type=script&lang=js"
import style0 from "./GoodsMultiplePickerWithCategory.vue?vue&type=style&index=0&id=31f0cfbe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f0cfbe",
  null
  
)

export default component.exports